/* src/app/main/pages/documents/sitemap/sitemap.component.css */
.sitemap {
  box-shadow: 0px 0px 3px #ccc;
}
.sitemap h4 {
  color: #E8882D;
}
.sitemap a {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 15px;
  display: block;
}
.sitemap .list-number {
  color: #E8882D;
  padding-right: 5px;
  font-weight: 500;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .border-after {
    margin-bottom: 20px;
  }
}
/*# sourceMappingURL=sitemap.component.css.map */
